import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/user';
import uiReducer from './slices/ui';
import loanReducer from './slices/loan';
import paymentReducer from './slices/payment';
import calculationReducer from './slices/calculation';
import registrationReducer from './slices/registration';
import registrationDiscount from './slices/discounts';
import { calculationListenerMiddleware } from './listeners/calculationListeners';

export const store = configureStore({
  reducer: {
    user: userReducer,
    ui: uiReducer,
    loan: loanReducer,
    payment: paymentReducer,
    calculation: calculationReducer,
    registration: registrationReducer,
    discounts: registrationDiscount,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().prepend(calculationListenerMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
